/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ModalBody, ModalHeader, ModalNext } from '@jutro/components';
import {
    withValidation,
} from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import { TFPACustomQuoteService } from 'tfpa-capability-quoteandbind-residential';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import metadata from './StandardizeAddressPopUp.metadata.json5';
import styles from './StandardizeAddressPopUp.module.scss';
import messages from './StandardizeAddressPopUp.messages';

import { RadioField } from '@jutro/legacy/components';

const StandardizeAddressPopUp = props => {
    const {
        addressVM,
        updatePrimaryAddressVM,
        addressData,
        title,
        onResolve,
        isOpen,
        setComponentValidation,
        companyType,
        authHeader,
        xPortal
    } = props;
    const [newAddressVM, updateNewAddressVM] = useState(addressVM);
    const [updatedAddress, setUpdatedAddress] = useState(null);
    const formatAddress = ({ addressLine1, addressLine2, addressLine3, city, state, postalCode }) =>
    [addressLine1, addressLine2, addressLine3, city, state, postalCode].filter(Boolean).join(', ').replace(/,(\s*[^,]+)$/, ' $1');
    const enteredAddress = formatAddress(addressVM);
    const [pickListData, setPickListData] = useState([]);
    const [ noAddressMatchFound, setNoAddressMatchFound ] = useState(false);
    const [ multipleMatches, setMultipleMatches ] = useState(false);
    const [chosenAddress, setChosenAddress] = useState({});
    const [addressBackupCopy, setAddressBackupCopy] = useState({});
    const exactAddressFound = addressData.exactAddressFound;
    const partialAddressFound = addressData.partialAddressFound;
    const fullAddress = addressData.fullAddress;
    const isSingleAddress = addressData.isSingleAddress;
    const srcAddress = _.clone(addressVM);
    const translator = useContext(TranslatorContext);
    const [exactAddress, updateExactAddress] = useState(false);
    const [hasFullAddressChoices, updateHasFullAddressChoices] = useState(false);
    const [picklistTitle, setPicklistTitle] = useState('');
    const warningMessages = [];
    const [addressList, updateAddressList] = useState([]);
    const [ value, selectedValue] = useState('radio');
    const addressType = _.get(addressVM, 'addressType');
    
    useEffect(() => {

        if (addressData.address) {
            updateExactAddress(true);
        }
        if (addressData.pickList && addressData.pickList?.length > 0) {
            if (addressData?.pickList?.length === 1 && !addressData?.pickList[0]?.postalCode) {
                setMultipleMatches(false);
            } else {
                setMultipleMatches(true);
            }
            updateHasFullAddressChoices(addressData.hasFullAddressChoices);
        }
        setNoAddressMatchFound(!multipleMatches && !exactAddress);
        
        if (exactAddress) {
            setPicklistTitle(translator(messages.exactAddress));
        }
        if (multipleMatches) {
            clearWarnings();
            setPicklistTitle(translator(messages.seletAddress));
            warningMessages.push(translator(messages.verbose));
            if (hasFullAddressChoices) {
                warningMessages.push(translator(messages.hint));
            }
        }
        if (noAddressMatchFound) {
            clearWarnings();
            setPicklistTitle('');
            warningMessages.push(translator(messages.noMatchFound));
        }
    },
    [exactAddress, hasFullAddressChoices, multipleMatches, noAddressMatchFound, addressData, warningMessages]);
    
    useEffect(() => {
        let address = [];
        if (addressData.address === undefined) {
            addressData?.pickList?.map((item) => {
                address.push(item);
            })
            setPickListData(address);
        } else {
            address = [...addressList, addressData.address];
            updateAddressList(address);
        }
    },
    []);

    const updateLocationDataFromBackup = (targetAddress) => {
        if (targetAddress) {
            if (!targetAddress.county) {
                targetAddress.county = addressBackupCopy.county;
            }
        }
        return targetAddress;
    };

    const selectAddressTFPA = async (index) => {
        let theResult;
        try {
            const selectedItem = pickListData[index]; 

            if(!exactAddressFound){
                theResult = await TFPACustomQuoteService.pickStandardizedYourHomeAddress(selectedItem, authHeader);
            } else {
                theResult = addressList;
            }
            setChosenAddress(theResult);
            updateNewAddressVM(theResult);
            setUpdatedAddress(chosenAddress);
        } catch (erred) {
            console.error(`Error: ${erred}`);
        }
    };

    const selectAddressTWIA = async (index) => {
        let theResult;
        try {
            const selectedItem = pickListData[index];
            if(!exactAddressFound){
                theResult = await AddressStandardizationService.pickStandardizedAddress(selectedItem, authHeader);
            } else {
                theResult = addressList;
            }
            setChosenAddress(theResult);
            updateNewAddressVM(theResult);
            setUpdatedAddress(chosenAddress);
        } catch (erred) {
            console.error(`Error: ${erred}`);
        }
    };

    const selectAddressTWIACC = async (index) => {
        let theResult;
        try {
            const selectedItem = pickListData[index]; 

            if(!exactAddressFound){
                theResult = await AddressStandardizationServiceCC.pickStandardizedAddressCC(selectedItem, authHeader);
            } else {
                theResult = addressList;
            }
            setChosenAddress(theResult);
            updatePrimaryAddressVM(theResult);
            updateNewAddressVM(theResult);
            setUpdatedAddress(chosenAddress);
        } catch (erred) {
            console.error(`Error: ${erred}`);
        }
    };

    const onAddressSelection = async (index) => {
        if(xPortal !== 'CC'){
            if (companyType === "tfpa") {
                selectAddressTFPA(index);
            } else {
                selectAddressTWIA(index);
            }
        } else {
            selectAddressTWIACC( index);
        }
       
    };

    const clearWarnings = () => {
        warningMessages.splice(0, warningMessages.length);
    };

    const okAction = async () => {
        if (noAddressMatchFound && xPortal === 'PE') {
            const anAddress = { ...srcAddress, isOverridden_Ext: true };
            const overrideAddress = await AddressStandardizationService.pickOverrideAddress(anAddress, authHeader);
            const altered = updateLocationDataFromBackup(overrideAddress);
            setChosenAddress(prev => ({
                ...altered,
                addressType: srcAddress.addressType,
                mustStandardize_Ext: prev?.mustStandardize_Ext,
            }));
            setAddressBackupCopy(altered);
            updatePrimaryAddressVM(overrideAddress);
            onResolve(overrideAddress);
        } else if ( noAddressMatchFound && xPortal === 'CC') {
            _.set(addressVM, 'addressVerifyStatusExt', 'overridden');
            updatePrimaryAddressVM(addressVM);
            setUpdatedAddress(addressVM);
            onResolve(addressVM);     
        } else if ( partialAddressFound && !fullAddress) {
            if(xPortal === 'CC'){
                _.set(addressVM, 'addressVerifyStatusExt', 'notvalidated');
                updatePrimaryAddressVM(addressVM);
            }
            updatePrimaryAddressVM(addressVM);
            setUpdatedAddress(addressVM);
            onResolve(addressVM);     
        } else if (multipleMatches) {
            if (chosenAddress && Object.keys(chosenAddress).length > 0) { // DE16715
                const updatedAddr = {
                    ...chosenAddress,
                    addressType: srcAddress.addressType,
                    mustStandardize_Ext: chosenAddress?.mustStandardize_Ext,
                };
        
                // If xPortal is 'CC', add additional field
                if (xPortal === 'CC') {
                    updatedAddr.addressVerifyStatusExt = 'validated';
                }
        
                setChosenAddress(updatedAddr);
                updatePrimaryAddressVM(updatedAddr);
                setUpdatedAddress(updatedAddr);
                onResolve(updatedAddr);
            } else { // DE16715
                updatePrimaryAddressVM(addressVM);
                setUpdatedAddress(addressVM);
                onResolve(addressVM);
            }
        } else if (exactAddress) {
            if (_.includes(_.get(addressData, 'address.postalCode'), 'ND')) {
                const anAddress = { ...srcAddress, isOverridden_Ext: true };
                const overrideAddress = await AddressStandardizationService.pickOverrideAddress(anAddress, authHeader);
                _.set(overrideAddress, 'plus4CodeExt', '14ND');
                const altered = updateLocationDataFromBackup(overrideAddress);
                setChosenAddress(prev => ({
                    ...altered,
                    addressType: srcAddress.addressType,
                    mustStandardize_Ext: prev?.mustStandardize_Ext,
                }));
                setAddressBackupCopy(altered);
                updatePrimaryAddressVM(overrideAddress);
                onResolve(overrideAddress);     
            } else {
                const updatedExactAddress = {
                    ...addressData.address,
                    addressType
                };
                
                setChosenAddress(updatedExactAddress);
                updatePrimaryAddressVM(updatedExactAddress);
                setUpdatedAddress(updatedExactAddress);
                onResolve(updatedExactAddress);
            }
        } else {
            updatePrimaryAddressVM(addressVM);
            onResolve(addressVM);
        }
    };

    const cancelAction = () => {
        onResolve();
    };

    const getCheckBoxExactAddress = useCallback(
        (item, index) => {
            if (_.includes(_.get(item, 'postalCode'), 'ND')) {
                return null;
            }
            return (
                <RadioField
                    availableValues={[
                        {
                            id: 'radio',
                            displayName: ''
                        }]
                    }
                    value = {value}
                    onValueChange={e => onAddressSelection(e, item, index)}
                />
            );
        },
        [onAddressSelection]
    );

    const resolvers = {
        resolveCallbackMap: {
            getCheckBoxExactAddress,
            onAddressSelection
        },
    };

    const overrideProps = {
        '@field': {
            showOptional: true,
        },
        okButton: {
            onClick: okAction
        },
        cancelButtonId: {
            onClick: cancelAction
        },
        pickupListTable: {
            data: pickListData
        },
        enteredAddress: {
            value: enteredAddress
        },
        message1: {
            visible: !noAddressMatchFound && !exactAddressFound && !partialAddressFound && !isSingleAddress
        },
        message2: {
            visible: !noAddressMatchFound && !exactAddressFound && !partialAddressFound && !isSingleAddress
        },
        message3: {
            visible: partialAddressFound && !exactAddressFound && !isSingleAddress
        },
        message4: {
            visible: (noAddressMatchFound && !exactAddressFound) || isSingleAddress
        },
        picklistTitle: {
            content: picklistTitle
        },
        noMatches: {
            visible: noAddressMatchFound
        },
        addressTable: {
            visible: !noAddressMatchFound && (multipleMatches || noAddressMatchFound) && fullAddress,
            data: pickListData
        },
        exactAddressTable: {
            visible: exactAddress && !noAddressMatchFound,
            data: addressList
        },
        partialAddressTable: {
            visible: partialAddressFound && !fullAddress,
            data: pickListData
        }
    };

    return (
        <ModalNext isOpen={isOpen} className={styles.editContactDetailsModal}>
            <ModalHeader title={title} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={updatedAddress}
                    overrideProps={overrideProps}
                    classNameMap={styles}
                    onValidationChange={setComponentValidation}
                    callbackMap={resolvers.resolveCallbackMap}
                />
            </ModalBody>
        </ModalNext>
    );
};

export default withValidation(StandardizeAddressPopUp);
